// Module
var code = "<div class=\"form-group\"> <label for=\"{{id}}\" class=\"control-label\"> {{to.Text}} {{to.Required ? '*' : ''}} </label> <formly-transclude></formly-transclude> <em ng-if=\"to.HelpText\" class=\"help-block\">{{to.HelpText}}</em> </div> ";
// Exports
export default code;